import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
/**
 * Validator to check the value is greater or equal to a given number
 * @param minValue The value to check
 */
export function greaterThanValidator(minValue = 0): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (typeof control.value === 'number' && control.value <= minValue) {
            return { minValue: true };
        }

        return null;
    };
}
